export default __webpack_public_path__ + "static/media/play.f273c86f.png";